import { EngineerHandle } from "resource-planner-model";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { AppState } from "../redux/AppTypes";

export const createEngineersSelector = () =>
  createSelector(
    (state: AppState) => state.engineers.items,
    (_: AppState, year: number) => year,
    (_: AppState, _year: number, month: number) => month,
    (items, year, month) =>
      Object.values(items)
        .map((e) => new EngineerHandle(e))
        .filter((e) => e.getCapacities(year, month).length > 0)
        .reduce((all, e) => {
          all[e.id] = e;
          return all;
        }, {} as { [engineerId: string]: EngineerHandle })
  );

export function useEngineers(
  year: number,
  month: number
): { [engineerId: string]: EngineerHandle } {
  const selector = useMemo(createEngineersSelector, []);
  return useSelector((state: AppState) => selector(state, year, month));
}
